export class VisualEditorDock {
  private container: HTMLElement | null = null;
  private toggleBtn: HTMLButtonElement | null = null;
  private isActive: boolean = false;
  private onToggleCallback: ((active: boolean) => void) | null = null;

  public render(
    parentElement: HTMLElement,
    totalWidgets: number,
    onToggle: (active: boolean) => void
  ): void {
    this.onToggleCallback = onToggle;

    this.container = document.createElement('div');
    this.container.className = 've-dock-container loumars-visual-editor-dock';
    this.container.id = 've-dock';
    this.container.setAttribute('data-id', 'loumars-visual-editor-dock');

    this.container.innerHTML = `
      <button type="button" class="ve-dock-btn loumars-visual-editor-toggle" id="ve-dock-toggle" data-id="loumars-visual-editor-toggle" aria-label="Toggle In-Page Edit Mode">
        <span class="ve-dock-beacon"></span>
        <span class="ve-dock-label">✏️ Edit Mode</span>
        <span class="ve-dock-counter" title="Total editable widgets on page">${totalWidgets}</span>
      </button>
    `;

    parentElement.appendChild(this.container);

    this.toggleBtn = this.container.querySelector('#ve-dock-toggle');
    this.toggleBtn?.addEventListener('click', () => {
      this.setActive(!this.isActive);
    });
  }

  public getIsActive(): boolean {
    return this.isActive;
  }

  public setActive(active: boolean): void {
    if (this.isActive === active) return;
    this.isActive = active;
    if (this.toggleBtn) {
      this.toggleBtn.classList.toggle('active', this.isActive);
      const label = this.toggleBtn.querySelector('.ve-dock-label');
      if (label) {
        label.textContent = this.isActive ? '⚡ Edit Mode ON' : '✏️ Edit Mode';
      }
    }
    if (this.onToggleCallback) {
      this.onToggleCallback(this.isActive);
    }
  }

  public updateWidgetCount(count: number): void {
    const counter = this.container?.querySelector('.ve-dock-counter');
    if (counter) {
      counter.textContent = String(count);
    }
  }

  public setDrawerOpen(isOpen: boolean): void {
    if (this.container) {
      this.container.classList.toggle('drawer-open', isOpen);
    }
  }

  public destroy(): void {
    this.container?.remove();
    this.container = null;
    this.toggleBtn = null;
  }
}
